import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-swatches/dist/vue-swatches.min.css'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import Helpers from '@/helper'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueFriendlyIframe from 'vue-friendly-iframe'
import messages from '@/locales'

import '@/filter'
import '@/directives'

// Layouts
import Default from '@/layouts/Default.vue'
import Login from '@/layouts/Login.vue'

Vue.use({
    install () {
        Vue.helpers = Helpers
        Vue.prototype.$helpers = Helpers
    }
})
Vue.use(VueFriendlyIframe)
Vue.use(vuetify, {
    theme: {
        dark: {
            primary: '#0A4792'
        }
    }
})
Vue.use(VueMeta, {
    // opcional: você pode definir algumas configurações globais aqui
    refreshOnceOnNavigation: true
})
Vue.use(VueI18n)
Vue.use(VueTheMask)
Vue.use(VueMoment, {
    moment
})
Vue.moment.tz.setDefault('UTC')
Vue.moment.defineLocale('pt-br', {
    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
    weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
    weekdaysMin: 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY [às] LT',
        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] LT'
    },
    calendar: {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ? '[Último] dddd [às] LT' : '[Última] dddd [às] LT'
        },
        sameElse: 'L'
    },
    relativeTime: {
        future: 'em %s',
        past: '%s atrás',
        s: 'segundos',
        m: 'um minuto',
        mm: '%d minutos',
        h: 'uma hora',
        hh: '%d horas',
        d: 'um dia',
        dd: '%d dias',
        M: 'um mês',
        MM: '%d meses',
        y: 'um ano',
        yy: '%d anos'
    },
    ordinal: '%dº'
})

Vue.component('default-layout', Default)
Vue.component('login-layout', Login)

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue()

const storedLocale = localStorage.getItem('locale') || 'pt-BR'

const i18n = new VueI18n({
    locale: storedLocale,
    fallbackLocale: 'pt-BR', // idioma de fallback
    messages
})

new Vue({
    data: {
        notifications: undefined,
        notificaitonId: undefined,
        newNotification: false
    },
    router,
    vuetify,
    i18n,
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },
    render: h => h(App)
}).$mount('#app')
